<script setup></script>
<script setup>
  import { defineProps } from 'vue'

  const props = defineProps({
    color: {
      color: String,
      default: '',
    },
  })
</script>
<template>
  <div :class="`m-headingForT-btn m-headingForT-btn--${props.color}`">
    <slot></slot>
  </div>
</template>

<style lang="scss" scoped>
  .m-headingForT-btn {
    width: 9.5vw;
    height: 2.6vw;
    display: inline-block;
    background: url('~@/assets/images/microsites/headingfortomorrow/_components/btn/btn.png') no-repeat center center /
      100% auto;
    margin: 0 auto;
    transition: background 0.3s;
    &:hover,
    &::after {
      content: '';
      background-image: url('~@/assets/images/microsites/headingfortomorrow/_components/btn/btn-hover.png');
    }
  }

  .m-headingForT-btn--yellow {
    background: url('~@/assets/images/microsites/headingfortomorrow/_components/btn/btn-yellow.png') no-repeat center
      center / 100% auto;
    &:hover,
    &::after {
      content: '';
      background-image: url('~@/assets/images/microsites/headingfortomorrow/_components/btn/btn-yellow-hover.png');
    }
  }

  .tablet {
    .m-headingForT-btn {
      width: 22.5vw;
      height: 5.6vw;
    }
  }
  .mobile {
    .m-headingForT-btn {
      width: 39.5vw;
      height: 9.6vw;
    }
  }
</style>
